import { isValid, parse } from 'date-fns';
import {
  IWeddingEvent,
  IWeddingEvent2,
} from '@bridebook/models/source/models/Weddings/Events.types';
import {
  DATE_FORMAT,
  format,
  parseIsoOnlyDate,
} from '@bridebook/web/lib/time-date-manipulation/time-date-manipulation';

interface FormatEventDateOptions {
  withEndTime?: boolean;
}

export const formatEventDateAndTime = (
  date: string,
  time: IWeddingEvent2['time'],
  options?: FormatEventDateOptions,
) => {
  if (!date) return '';
  const start = time?.startTime;
  const end = time?.endTime;

  const dateString = format(
    parseIsoOnlyDate(date),
    DATE_FORMAT.DATE.WITH_SHORT_DAY_SHORT_MONTH_YEAR,
  );
  const startTimeString = start
    ? format(parse(start, 'HH:mm', new Date()), DATE_FORMAT.TIME.SHORT)
    : '';
  const endTimeString = end ? format(parse(end, 'HH:mm', new Date()), DATE_FORMAT.TIME.SHORT) : '';

  if (startTimeString && endTimeString && options?.withEndTime) {
    return `${startTimeString} - ${endTimeString}, ${dateString}`;
  }

  if (startTimeString) {
    return `${startTimeString}, ${dateString}`;
  }

  return dateString;
};

export const formatEventTime = (timeString: string) => {
  const parsedTime = parse(timeString, 'HH:mm', new Date());
  if (!parsedTime || !isValid(parsedTime)) return '';
  const formattedTime = format(parsedTime, DATE_FORMAT.TIME.SHORT);
  return formattedTime;
};

export const formatEventTimeRange = (time: IWeddingEvent['time'], suffix: string = '') => {
  const start = time?.startTime;
  const end = time?.endTime;

  if (start && end) {
    return `${formatEventTime(start)} - ${formatEventTime(end)}${suffix}`;
  }

  if (start) {
    return `${formatEventTime(start)}${suffix}`;
  }

  return '';
};

export const formatEventDate = (dateString: string, shouldUseOrdinals: boolean) => {
  const parsedDate = parseIsoOnlyDate(dateString);
  if (!parsedDate || !isValid(parsedDate)) return '';
  const formattedDate = format(
    parsedDate,
    shouldUseOrdinals ? DATE_FORMAT.DATE.CALENDAR.LONG : DATE_FORMAT.DATE.LONG,
  );
  return formattedDate;
};
